<template>
  <div>
    <h2 class="mb-5 mt-5">Confirm Details</h2>
    <div class="d-flex align-center">
      <v-icon color="primary" class="mr-2" large>
        mdi-clipboard-text-outline
      </v-icon>
      <div clas="d-flex flex-column">
        <h3>{{ interviewFormat.interviewName | capitalize }}</h3>
        <span class="secondary-text">
          {{ interviewFormat.duration }}
          {{ pluralize("minutes", interviewFormat.duration) }}
        </span>
      </div>
    </div>
    <div>
      <h3 class="mt-2 mb-1" v-if="size(inviteData.interviewers)">
        Interviewers
      </h3>
      <v-chip
        class="selected-worker-chip mr-2"
        :key="interviewer.id"
        v-for="interviewer in inviteData.interviewers"
      >
        <v-icon>mdi-account</v-icon> {{ interviewer | fullName }}
      </v-chip>
      <div v-if="inviteData.location">
        <h3 class="mt-4 mb-2">Location</h3>
        {{ location }}
      </div>
      <h3 class="mt-4 mb-2" v-if="size(allSlots)">
        Slots
      </h3>
      <GroupedSlotList :slots="allSlots" />
      <h3 class="mt-4 mb-2">Candidates</h3>
      <v-chip
        class="selected-worker-chip mr-2"
        :key="candidate.id"
        v-for="candidate in inviteData.candidates"
      >
        <v-icon>mdi-account</v-icon> {{ candidate.fullName }}
      </v-chip>
    </div>
  </div>
</template>

<script>
import pluralize from "pluralize";
import { getFullName } from "@/utils/users";
import { size } from "lodash";
import GroupedSlotList from "@/views/bookings/BookingInterviews/components/dialogs/SelfScheduleInvites/SelfScheduleInvite/steps/SelfScheduleSlots/components/GroupedSlotList";

export default {
  props: {
    interviewFormat: {
      type: Object,
      required: true
    },
    inviteData: {
      type: Object,
      required: true
    },
    allSlots: {
      type: Array,
      required: true
    }
  },
  components: {
    GroupedSlotList
  },
  computed: {
    location() {
      const { line1, line2, line3 } = this.inviteData.location;
      return [line1, line2, line3].filter(Boolean).join(", ");
    }
  },
  methods: {
    pluralize,
    size
  },
  filters: {
    fullName(user) {
      return getFullName(user);
    }
  }
};
</script>

<style lang="scss"></style>
